'use client';
import CaseStudyItem from '@/components/common/case-study';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import React from 'react';
import MetaTags from '@/components/meta-tag/meta-tag';
import BorderEdge from '@/components/common/border-edge';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const CaseStudies: React.FC = () => {
    return (
        <>
            <MetaTags />
            {/* work hero start */}
            <section className="hero work-height border-b border-[#dfe5eb]">
                <div className="container lg:container md:mx-auto top-hero">
                    <div className="lg:grid hero-row gap-6 relative z-[1] h-full">
                        <div className="w-full">
                            <div className="inline-flex flex-col lg:items-start gap-6 hero-content justify-center h-full">
                                <h1 className="mb-0">Case Studies</h1>
                                <p className="mb-0 fw-600">
                                    Our case study section encompasses a diverse range of projects expertly managed by our team.
                                    These case studies offer comprehensive insights into our team&apos;s proficiency and
                                    expertise. Our primary objective is to provide innovative solutions that elevate our
                                    clients&apos; businesses to new heights.
                                </p>
                            </div>
                        </div>
                        <div className="text-center md:text-center lg:self-center hidden lg:block">
                            <Image
                                src="/img/work/case-studies-hero@2x.webp"
                                alt="work hero"
                                title="work hero"
                                className="hero-Work-img"
                                height={748}
                                width={1110}
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
                <div className="text-center md:text-center lg:self-center lg:hidden">
                    <Image
                        src="/img/work/case-studies-hero@2x.webp"
                        alt="work hero"
                        title="work hero"
                        className="hero-Work-img"
                        height={748}
                        width={1110}
                        loading="lazy"
                    />
                </div>
            </section>
            {/*  hero end */}
            {/* <Filters /> */}
            <section className="section-py case-study">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-1">
                        <CaseStudyItem
                            
                            thumbnail="/img/case-study/img-casestudy-subscription-2x.webp"
                            alt="Subscription-based Online Discount Platform"
                            csTitle="Subscription-based Online Discount Platform"
                            para="We developed a subscription-based online discount platform that offers subscribers 
exclusive discounts, deals and offers from various restaurant chains and online 
retailers."
                            url={'/case-studies/subscription-based-online-discount-platform'}
                            
                        />
                        <CaseStudyItem
                            
                            thumbnail="/img/case-study/img-casestudy-allinone-2x.webp"
                            alt="All-in-one Online Resort Management Platform"
                            csTitle="All-in-one Online Resort Management Platform"
                            para="We created an All-in-one Resort Management platform, carefully designed to make 
resort operations smoother and more profitable, providing guests with a seamless 
experience."
                            url={'/case-studies/all-in-one-online-resort-management-platform'}
                            
                        />
                        <CaseStudyItem
                            
                            thumbnail="/img/case-study/img-casestudy-ondemand-2x.webp"
                            alt="On-demand Cleaning Booking Services Platform"
                            csTitle="On-demand Cleaning Booking Services Platform"
                            para="We crafted an amazing On-demand cleaning booking services platform for a startup.
Our solution connects homeowners with trusted professional cleaners, transforming 
the way cleaning is done."
                            url={'/case-studies/on-demand-cleaning-booking-services-platform'}
                            
                        />
                        <CaseStudyItem
                            
                            thumbnail="/img/case-study/img-casestudy-erp-2x.webp"
                            alt="On-demand Cleaning Booking Services Platform"
                            csTitle="ERP Implementation for Furniture Manufacturer and Trader"
                            para="Odoo Implementation, Customization, and User Training for tailored Web Portal and Mobile/Tablet App Solutions."
                            url={'case-studies/pashwa-case-study'}
                            
                        />
                    </div>
                </div>
            </section>
            <BorderEdge color="text-white" bg="bg-blue" />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default CaseStudies;
